import { gql } from '@apollo/client';

export const GET_USER = gql`
  query getUser($id: String!) {
    getUser(id: $id)
      @rest(type: "users", path: "/{args.id}", endpoint: "users") {
      id
      initials
      email
      fullName
      phone
      company
      jobTitle
      profilePicture
      lastUpdated
    }
  }
`;
